<div
  class="input-wrapper"
  [class.clickable-container]="isAbleToSelectCustomer()"
  (click)="openCustomerSelectionDialog()"
>
  <div>
    {{ selectedCustomer | customerNameFormatter : businessObject?.telephone }}
  </div>

  <mat-icon *ngIf="isAbleToSelectCustomer()" color="primary"
    >arrow_drop_down</mat-icon
  >
</div>
